import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { CalculatorPage } from '@/components/calculator/calculator-page'
import { SESSION_KEY_CALCULATOR_VISITED } from '@/lib/calculator/constants'

function CalculatorRoute() {
  useEffect(() => {
    sessionStorage.setItem(SESSION_KEY_CALCULATOR_VISITED, 'true')
  }, [])

  return <CalculatorPage />
}

export const Route = createFileRoute('/_auth/_main-layout/calculator')({
  component: CalculatorRoute,
})
